import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PagePanel } from 'edenred-ui';

import { getApplicationLanguageId } from '@epi-store/application/application.selectors';
import { getSupportContent } from '@epi-repositories/SupportRepository';
import {
  SupportPageGuideSection,
  SupportPageSection
} from '@epi-models/pages/Support';

import { SupportLinks } from './SupportLinks';
import { SupportContact } from './SupportContact';
import { SupportSocials } from './SupportSocials';
import { SupportGuides } from './SupportGuides';

export const Support = () => {
  const language = useSelector(getApplicationLanguageId);
  const { t } = useTranslation();

  const linksContent = getSupportContent().sections.filter(
    item => item.language === language
  ) as SupportPageSection[];

  const guidesContent = getSupportContent().guides.filter(
    item => item.language === language
  ) as SupportPageGuideSection[];

  return (
    <PagePanel title={t('containers.help.title')}>
      <SupportGuides data={guidesContent} />
      <SupportLinks data={linksContent} />
      <SupportContact />
      <SupportSocials />
    </PagePanel>
  );
};
